<template>
	<div id="app">
		<Hero />
		<main>
			<Logo />
			<Studio scroller="right" />
			<Gallery scroller="left" />
			<Team />
			<Contact scroller="left" />
			<!-- <section class="map">
				<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2664.5088539570465!2d16.281848216061697!3d48.10041887922049!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476daf404926791b%3A0x860b6e26c107bddf!2sJAKS%20-%20Tattoo%20%26%20Piercing!5e0!3m2!1sde!2sat!4v1600711693995!5m2!1sde!2sat" frameborder="0" allowfullscreen=""></iframe>
			</section> -->
		</main>
	</div>
</template>

<script>
	import Hero from './components/Hero.vue'
	import Logo from './components/Logo.vue'
	import Studio from './components/Studio.vue'
	import Gallery from './components/Gallery.vue'
	import Team from './components/Team.vue'
	import Contact from './components/Contact.vue'

	import W from '@wamms/tinylib'
	import scrolling from './scripts/scrolling'
	import observer from './scripts/observer'

	export default {
		name: 'App',
		components: {
			Hero,
			Logo,
			Studio,
			Gallery,
			Team,
			Contact
		},
		mounted() {
			// reset scrolling on reload
			W.scroll.reset()

			// initialize animations
			if ( 'IntersectionObserver' in window ) {
				W.body.classList.add( 'observer' )
				observer.init()
				scrolling.init()
			}
		}
	}
</script>

<style lang="scss">
	@import '~destyle.css/destyle.css';
	@import './styles/config.scss';
	@import './styles/global.scss';
	@import './styles/issues.scss';
	@import './styles/sections.scss';
	@import './styles/hero.scss';
	@import './styles/common.scss';
	@import './styles/gallery.scss';
	@import './styles/team.scss';
	@import './styles/contact.scss';
	@import './styles/observer.scss';
</style>
